import {
  AfterContentInit,
  Component,
  ContentChildren,
  ElementRef,
  HostBinding,
  Input,
  QueryList,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';

import { JdInputDirective } from './jd-input.directive';
import { toBoolean } from '../core/convert';
export type TInputGroupIconClass = string | string[] | Set<string> | { [klass: string]: any; };
export type JdInputGroupSizeType = 'large' | 'default' | 'small';

@Component({
  selector: 'jd-input-group',
  preserveWhitespaces: false,
  templateUrl: './jd-input-group.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./style/index.css'],
})

export class JdInputGroupComponent implements AfterContentInit {
  private _addOnBefore: string | TemplateRef<void> = '';
  private _addOnAfter: string | TemplateRef<void> = '';
  private _prefix: string | TemplateRef<void> = '';
  private _suffix: string | TemplateRef<void> = '';
  private _size: JdInputGroupSizeType = 'default';
  private _compact = false;
  private _search = false;
  isAddOnBeforeString: boolean;
  isAddOnAfterString: boolean;
  isPrefixString: boolean;
  isSuffixString: boolean;
  @ContentChildren(JdInputDirective) jdInputDirectiveQueryList: QueryList<JdInputDirective>;
  @Input() addOnBeforeIcon: TInputGroupIconClass;
  @Input() addOnAfterIcon: TInputGroupIconClass;
  @Input() prefixIcon: TInputGroupIconClass;
  @Input() suffixIcon: TInputGroupIconClass;

  @Input() set size(value: JdInputGroupSizeType) {
    this._size = value;
    this.updateChildrenInputSize();
  }

  get size(): JdInputGroupSizeType {
    return this._size;
  }

  @Input()
  @HostBinding(`class.ant-input-group-compact`)
  set compact(value: boolean) {
    this._compact = toBoolean(value);
  }

  get compact(): boolean {
    return this._compact;
  }

  @Input()
  set addOnBefore(value: string | TemplateRef<void>) {
    this.isAddOnBeforeString = !(value instanceof TemplateRef);
    this._addOnBefore = value;
  }

  get addOnBefore(): string | TemplateRef<void> {
    return this._addOnBefore;
  }

  @Input()
  set addOnAfter(value: string | TemplateRef<void>) {
    this.isAddOnAfterString = !(value instanceof TemplateRef);
    this._addOnAfter = value;
  }

  get addOnAfter(): string | TemplateRef<void> {
    return this._addOnAfter;
  }

  @Input()
  set prefix(value: string | TemplateRef<void>) {
    this.isPrefixString = !(value instanceof TemplateRef);
    this._prefix = value;
  }

  get prefix(): string | TemplateRef<void> {
    return this._prefix;
  }

  @Input()
  set suffix(value: string | TemplateRef<void>) {
    this.isSuffixString = !(value instanceof TemplateRef);
    this._suffix = value;
  }

  get suffix(): string | TemplateRef<void> {
    return this._suffix;
  }

  @Input()
  @HostBinding(`class.ant-input-search-enter-button`)
  @HostBinding(`class.ant-input-search`)
  set search(value: boolean) {
    this._search = toBoolean(value);
  }

  get search(): boolean {
    return this._search;
  }

  get isLarge(): boolean {
    return this.size === 'large';
  }

  get isSmall(): boolean {
    return this.size === 'small';
  }

  get isAffix(): boolean {
    return (!!(this.suffix || this.prefix || this.prefixIcon || this.suffixIcon));
  }

  @HostBinding('class.ant-input-affix-wrapper')
  get isAffixWrapper(): boolean {
    return (!!(this.suffix || this.prefix || this.prefixIcon || this.suffixIcon)) && !this.isAddOn;
  }

  @HostBinding('class.ant-input-group-wrapper')
  get isAddOn(): boolean {
    return !!(this.addOnAfter || this.addOnBefore || this.addOnAfterIcon || this.addOnBeforeIcon);
  }

  @HostBinding('class.ant-input-group')
  get isGroup(): boolean {
    return false;
    // return (!this.isAffix) && (!this.isAddOn);
  }

  @HostBinding(`class.ant-input-group-lg`)
  get isLargeGroup(): boolean {
    return this.isGroup && this.isLarge;
  }

  @HostBinding(`class.ant-input-group-wrapper-lg`)
  get isLargeGroupWrapper(): boolean {
    return this.isAddOn && this.isLarge;
  }

  @HostBinding(`class.ant-input-affix-wrapper-lg`)
  get isLargeAffix(): boolean {
    return this.isAffixWrapper && this.isLarge;
  }

  @HostBinding(`class.ant-input-search-lg`)
  get isLargeSearch(): boolean {
    return this.search && this.isLarge;
  }

  @HostBinding(`class.ant-input-group-sm`)
  get isSmallGroup(): boolean {
    return this.isGroup && this.isSmall;
  }

  @HostBinding(`class.ant-input-affix-wrapper-sm`)
  get isSmallAffix(): boolean {
    return this.isAffixWrapper && this.isSmall;
  }

  @HostBinding(`class.ant-input-group-wrapper-sm`)
  get isSmallGroupWrapper(): boolean {
    return this.isAddOn && this.isSmall;
  }

  @HostBinding(`class.ant-input-search-sm`)
  get isSmallSearch(): boolean {
    return this.search && this.isSmall;
  }

  updateChildrenInputSize(): void {
    if (this.jdInputDirectiveQueryList) {
      this.jdInputDirectiveQueryList.forEach(item => item.size = this.size);
    }
  }

  constructor(private el: ElementRef) {

  }

  ngAfterContentInit(): void {
    this.updateChildrenInputSize();
  }
}
